import { dropdownConstants } from '../constant';
export const dropdownAction = {
    dropdownUpdate,
};

function dropdownUpdate(dropdownObj) {
    return (dispatch) => {
        if (dropdownObj) {
            if (dropdownObj.item && dropdownObj.isToggle) {
                if (dropdownObj.item === 'footer-language') {
                    dropdownObj.footerLanguageDropdown = !dropdownObj.footerLanguageDropdown;
                } else if (dropdownObj.item === 'language') {
                    dropdownObj.languageDropdown = !dropdownObj.languageDropdown;
                    dropdownObj.myAccountDropdown = false;
                    dropdownObj.sidebarDropdown = false;
                } else if (dropdownObj.item === 'myAccount') {
                    dropdownObj.myAccountDropdown = !dropdownObj.myAccountDropdown;
                    dropdownObj.languageDropdown = false;
                } else if (dropdownObj.item === 'telcode') {
                    dropdownObj.telcodeDropdown = !dropdownObj.telcodeDropdown;
                } else if (dropdownObj.item === 'bank') {
                    dropdownObj.bankDropdown = !dropdownObj.bankDropdown;
                } else if (dropdownObj.item === 'provider') {
                    dropdownObj.providerDropdown = !dropdownObj.providerDropdown;
                } else if (dropdownObj.item === 'guide') {
                    dropdownObj.guideDD = !dropdownObj.guideDD;
                } else if (dropdownObj.item === 'depositProgress') {
                    dropdownObj.depositProgressDD = !dropdownObj.depositProgressDD;
                } else if (dropdownObj.item === 'login') {
                    dropdownObj.loginDropdown = !dropdownObj.loginDropdown;
                } else if (dropdownObj.item === 'cryptoShare') {
                    dropdownObj.cryptoShareDD = !dropdownObj.cryptoShareDD;
                } else if (dropdownObj.item === 'referralShare') {
                    dropdownObj.referralShareDD = !dropdownObj.referralShareDD;
                } else if (dropdownObj.item === 'sidebar') {
                    dropdownObj.sidebarDropdown = !dropdownObj.sidebarDropdown;
                    dropdownObj.languageDropdown = false;
                } else if (dropdownObj.item === 'withdraw') {
                    dropdownObj.withdrawDropdown = !dropdownObj.withdrawDropdown;
                }
            }
        } else {
            dropdownObj = {
                footerLanguageDropdown: false,
                languageDropdown: false,
                myAccountDropdown: false,
                loginDropdown: false,
                telcodeDropdown: false,
                bankDropdown: false,
                providerDropdown: false,
                certainElementDropdown: null,
                sidebarDropdown: false,
                withdrawDropdown: false,
            };
        }
        dispatch({ type: dropdownConstants.DROPDOWN_UPDATE, payload: dropdownObj });
    };
}
